import localization from '@cdo/apps/localization';

export default () => {
  return localization.locale;
};
